import React, { useEffect, useState } from "react";
// import './ClientSelectionModal.css';
import Modal from 'react-modal';
import RegionIcon from './images/region_icon.png';
import FFIcon from './images/ff-icon.png';
import API from '../API';
import { useAuth0 } from "@auth0/auth0-react";

const ClientSelectionModal = ({accessToken, showClientSelectionModal, setShowClientSelectionModal, callback, furioosCallback, deeplink}) => {
    const [regions, setRegions] = useState([]);
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        async function fetchData() {
            if (isAuthenticated) {
                const accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                const response = await API.getAvailableServers(accessToken);
                if (response.status !== 200) {
                    console.log("Error getting available servers.");
                    return;
                }

                const data = await response.json();
                setRegions(data.servers);
            }
        }
        fetchData();
    }, [isAuthenticated, getAccessTokenSilently]);
    async function useDesktopClient() {
        //window.location.href = deeplink
        setShowClientSelectionModal(false);
        callback();
    }
    async function playInBrowser() {
        setShowClientSelectionModal(false);
        furioosCallback();
    }

    return (
            <Modal
            isOpen={showClientSelectionModal}
            parentSelector={()=> document.querySelector('.enter-world-container')}
            className="RegionSelectionModal__Content ff-modal-content ff-center"
            overlayClassName="RegionSelectionModal__Overlay"
            onRequestClose={() => setShowClientSelectionModal(false)}
            shouldCloseOnOverlayClick={false}>
            <img style={{objectFit: "contain"}} src={FFIcon} alt="Future Fest Icon" />
            <h2 className="connect-wallet-title">Welcome to Future Fest</h2>
            <p className="connect-wallet-subtitle">Your experience is now loading. Get ready! <br/> (Windows Only)</p>
            <button className="ff-button" onClick={useDesktopClient}>Use Desktop Client</button>
            <p className="connect-wallet-subtitle">------- or -------</p>
            <button onClick={playInBrowser} style={{
                border: '0px',
                backgroundColor: 'transparent',
                fontFamily: 'Poppins',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '16px',
                lineHeight: '24px',
                textAlign: 'center',
                letterSpacing: '0.2px',
                color: '#5239EA'}}>Play in browser<br/> (recommended for laptops)</button>
            </Modal>
    );
};

export default ClientSelectionModal;
